export enum ErrorCode {
    exceptionCaught = 'EXCEPTION_CAUGHT',
    recordNotFound = 'RECORD_NOT_FOUND',
    notAllowed = 'NOT_ALLOWED',
    parentRecordNotFound = 'PARENT_RECORD_NOT_FOUND',
    childRecordNotFound = 'CHILD_RECORD_NOT_FOUND',
    existsCheckFail = 'EXISTS_CHECK_FAIL',
    contextInvalid = 'CONTEXT_INVALID',
    inputsInvalid = 'INPUTS_INVALID',
    schemaInvalid = 'SCHEMA_INVALID',
    queryStringInvalid = 'QUERY_STRING_INVALID',
    urlParamsInvalid = 'URL_PARAMS_INVALID',
    invalidExtendedInstance = 'INVALID_EXTENDED_INSTANCE',
}
